<template>
    <el-dialog :visible.sync="visible" title="凭证" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
<!--            <el-form-item label="买家用户id" prop="buyerMemberId">-->
<!--                <el-input v-model="dataForm.buyerMemberId" placeholder="买家用户id"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="卖家用户id" prop="sellerMemberId">-->
<!--                <el-input v-model="dataForm.sellerMemberId" placeholder="卖家用户id"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="0 未打款-->
<!--1 已打款-->
<!--2 已收款-->
<!--3 卖家申诉中-->
<!--4 申述已处理-->
<!--5 买家支付超时" prop="status">-->
<!--                <el-input v-model="dataForm.status" placeholder="0 未打款-->
<!--1 已打款-->
<!--2 已收款-->
<!--3 卖家申诉中-->
<!--4 申述已处理-->
<!--5 买家支付超时"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="优果数" prop="integrationAmount">-->
<!--                <el-input v-model="dataForm.integrationAmount" placeholder="优果数"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="价格" prop="price">-->
<!--                <el-input v-model="dataForm.price" placeholder="价格"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="卖家手机号" prop="sellerMobile">-->
<!--                <el-input v-model="dataForm.sellerMobile" placeholder="卖家手机号"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="卖家银行卡id" prop="bankId">-->
<!--                <el-input v-model="dataForm.bankId" placeholder="卖家银行卡id"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="凭证内容:" prop="integrationAmount">
                <template slot-scope="scope">
                    <img :src="dataForm.certificateImage" alt="" width="300" height="300" readonly="readonly">
                </template>
            </el-form-item>
<!--            <el-form-item label="凭证图片" prop="certificateImage">-->
<!--                <el-input v-model="dataForm.certificateImage" placeholder="凭证图片"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="创建时间" prop="createTime">-->
<!--                <el-input v-model="dataForm.createTime" placeholder="创建时间"></el-input>-->
<!--            </el-form-item>-->
        </el-form>
<!--        <template slot="footer">-->
<!--            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>-->
<!--            <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>-->
<!--        </template>-->
    </el-dialog>
</template>

<script>
    import debounce from 'lodash/debounce'

    export default {
        data() {
            return {
                visible: false,
                dataForm: {
                    id: '',
                    buyerMemberId: '',
                    sellerMemberId: '',
                    status: '',
                    integrationAmount: '',
                    price: '',
                    sellerMobile: '',
                    bankId: '',
                    certificateImage: '',
                    createTime: ''
                }
            }
        },
        computed: {
            dataRule() {
                return {
                    buyerMemberId: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    sellerMemberId: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    status: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    integrationAmount: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    price: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    sellerMobile: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    bankId: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    certificateImage: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    createTime: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            init() {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    if (this.dataForm.id) {
                        this.getInfo()
                    }
                })
            },
            // 获取信息
            getInfo() {
                this.$http.get(`/csm/order/${this.dataForm.id}`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm = {
                        ...this.dataForm,
                        ...res.data
                    }
                }).catch(() => {
                })
            },
            // 表单提交
            dataFormSubmitHandle: debounce(function () {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    this.$http[!this.dataForm.id ? 'post' : 'put']('/csm/order/', this.dataForm).then(({data: res}) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {
                    })
                })
            }, 1000, {'leading': true, 'trailing': false})
        }
    }
</script>
